import { Container, Ticker } from 'pixi.js';
import { ParticlesStore } from './particlesStore';
import { ParticlesView } from './particlesView';

export class ParticlesController {
    store;
    view;
    activeEmitters = [];
    options;
    emittersMap = new Map();

    constructor(options) {
        this.options = options;
        if (!this.options.EmitterClass && this.options.isStage) {
            console.error('[ParticlesController] EmitterClass не передан в настройки!');
        }
        this.store = new ParticlesStore(this.options);
        this.view = new ParticlesView(this.options);
    }

    async init() {
        await this.store.loadAssets();
        Ticker.shared.add(this.update, this);
    }

    /**
  
  Создает эмиттер, но НЕ запускает его и НЕ добавляет на финальную сцену.
  */
    createEmitter(effectName, particleId) {
        if (!particleId) {
            console.error(`
   [ParticlesController] ❌ ОШИБКА: Не передан уникальный particleId для "${effectName}"
 `);
            return null;
        } if (this.emittersMap.has(particleId)) {
            return this.emittersMap.get(particleId).emitter;
        }
        const isStage = this.options.isStage;
        const configEntry = this.options.systemConfig[effectName]; if (!configEntry) {
            console.error(`[ParticlesController] ❌ Базовый конфиг "${effectName}" не найден.`);
            return null;
        } const finalConfig = this.store.configs.get(configEntry.name);
        if (!finalConfig) {
            console.error(`[ParticlesController] ❌ Данные для "${configEntry.name}" не загружены.`);
            return null;
        } const { libType, EmitterClass } = this.options;
        if (!EmitterClass) {
            console.error(`[ParticlesController] ❌ КРИТИЧЕСКАЯ ОШИБКА: EmitterClass равен undefined!`);
            return null;
        } let emitter; try {
            if (libType === 'custom') {
                const actualConfig = finalConfig.config.data ? finalConfig.config.data : finalConfig.config;
                emitter = EmitterClass.create({
                    textures: Array.from(finalConfig.textures),
                    emitterConfig: actualConfig,
                }); if (!emitter) throw new Error('EmitterClass.create вернул null или undefined.');
            } else {
                emitter = new EmitterClass(new Container(), finalConfig);
                emitter.emit = false; emitter._tempContainer = emitter.parent;
            }
        } catch (error) {
            console.error(`[ParticlesController] ❌ ОШИБКА при сборке эффекта "${effectName}":, error`);
            return null;
        }
        this.emittersMap.set(particleId, {
            emitter,
            effectName,
        }); if (isStage)
            console.log(`[ParticlesController] 🛠️ Эффект "${effectName}" СОЗДАН (ожидает запуска).`); return emitter;
    } /**
Запускает ранее созданный эмиттер, помещает в нужный контейнер и добавляет в тикер.
*/
    startCreatedEmitter(effectName, emitter, playOptions = {}) {
        if (!emitter) return null; const isStage = this.options.isStage;
        const parentContainer = playOptions.parent || this.view.getContainer(effectName); if (!parentContainer) {
            console.error(
                `[ParticlesController] ❌ ОШИБКА: Родительский контейнер для "${effectName}" отсутствует!`
            );
            return null;
        } const { libType } = this.options; try {
            if (libType === 'custom') {
                const displayObject = emitter.view || emitter.container || emitter; parentContainer.addChild(displayObject); if (playOptions.x !== undefined && playOptions.y !== undefined) {
                    emitter.updatePosition({ x: playOptions.x, y: playOptions.y }, true);
                } emitter.onComplete = () => {
                    emitter.onComplete = () => { };

                    if (isStage)
                        console.log(`[ParticlesController] 🧹 Отложенный эффект "${effectName}" завершился.`);
                    this.killParticle(emitter);
                }; emitter.play();
            } else {
                if (emitter._tempContainer) {
                    parentContainer.addChild(emitter._tempContainer);
                } if (playOptions.x !== undefined && playOptions.y !== undefined) {
                    emitter.updateOwnerPos(playOptions.x, playOptions.y);
                } else {
                    emitter.updateOwnerPos(0, 0);
                }
                emitter.emit = true;
            }
        } catch (error) {
            console.error(
                `[ParticlesController] ❌ ОШИБКА при запуске отложенного эффекта "${effectName}":`,
                error
            );
            return null;
        } this.activeEmitters.push({
            emitter,
            parentContainer,
            followTarget: playOptions.follow,
            name: effectName,
            isStopped: false,
        }); if (isStage)
            console.log(`[ParticlesController] 🎯 УСПЕХ: Отложенный эффект "${effectName}" запущен!`); return emitter;
    } getById(particleId) {
        const data = this.emittersMap.get(particleId);
        return data ? data.emitter : null;
    } stopById(particleId) {
        const emitter = this.getById(particleId);
        if (emitter) this.stopParticle(emitter);
    } destroyById(particleId) {
        const emitter = this.getById(particleId);
        if (emitter) {
            this.killParticle(emitter);
            this.emittersMap.delete(particleId);
        }
    } update(delta) {
        for (let i = this.activeEmitters.length - 1; i >= 0; i -= 1) {
            const item = this.activeEmitters[i];
            const { libType } = this.options; if (item.followTarget) {
                const pos = item.followTarget.getGlobalPosition();
                const localPos = item.parentContainer.toLocal(pos); if (libType === 'custom' && typeof item.emitter.updatePosition === 'function') {
                    item.emitter.updatePosition({ x: localPos.x, y: localPos.y }, false);
                } else if (typeof item.emitter.updateOwnerPos === 'function') {
                    item.emitter.updateOwnerPos(localPos.x, localPos.y);
                }
            } if (libType === 'default') {
                item.emitter.update(delta * (1 / 60)); if (!item.emitter.emit && item.emitter.particleCount === 0) {
                    this._destroyEmitterItem(item, i);
                }
            } else if (libType === 'custom') {
                if (item.isStopped) {
                    this._destroyEmitterItem(item, i);
                }
            }
        }
    } playParticle(effectName, playOptions = {}) {
        const isStage = this.options.isStage; if (isStage) console.log(`[ParticlesController] 🚀 Старт эффекта: "${effectName}"`); const configEntry = this.options.systemConfig[effectName];
        if (!configEntry) {
            console.error(
                ` [ParticlesController] ❌ ОШИБКА: Базовый конфиг "${effectName}" не найден в systemConfig.`
            );
            return null;
        }
        if (isStage)
            console.log(`[ParticlesController] ✅ Шаг 1: Конфиг "${configEntry.name}" найден.`); const finalConfig = this.store.configs.get(configEntry.name);
        if (!finalConfig) {
            console.error(
                ` [ParticlesController] ❌ ОШИБКА: Данные (текстуры/конфиг) для "${configEntry.name}" не загружены в store.`
            );
            return null;
        }
        if (isStage)
            console.log(
                `[ParticlesController] ✅ Шаг 2: Текстуры и данные для "${configEntry.name}" готовы.`
            ); const parentContainer = playOptions.parent || this.view.getContainer(effectName);
        if (!parentContainer) {
            console.error(
                `[ParticlesController] ❌ ОШИБКА: Родительский контейнер для "${effectName}" отсутствует!`
            );
            return null;
        }
        if (isStage)
            console.log(
                `[ParticlesController] ✅ Шаг 3: Контейнер определен (${parentContainer.name || 'Без имени'
                }).`
            ); const { libType, EmitterClass } = this.options; if (!EmitterClass) {
                console.error(
                    `[ParticlesController] ❌ КРИТИЧЕСКАЯ ОШИБКА: EmitterClass равен undefined! Библиотека не передана.`
                );
                return null;
            } if (isStage)
            console.log(`[ParticlesController] ⚙️ Шаг 4: Инициализация через библиотеку [${libType}]...`); let emitter; try {
                if (libType === 'custom') {
                    if (typeof EmitterClass.create !== 'function') {
                        console.error(`[ParticlesController] ❌ ОШИБКА: У библиотеки нет метода .create()!`);
                        return null;
                    } const actualConfig = finalConfig.config.data ? finalConfig.config.data : finalConfig.config; emitter = EmitterClass.create({
                        textures: Array.from(finalConfig.textures),
                        emitterConfig: actualConfig,
                    }); console.log(
                        `[ParticlesController] 📦 Что вернула библиотека EmitterClass.create?:`,
                        emitter
                    ); if (!emitter) throw new Error('EmitterClass.create вернул null или undefined.'); const displayObject = emitter.view || emitter.container || emitter; parentContainer.addChild(displayObject); if (playOptions.x !== undefined && playOptions.y !== undefined) {
                        emitter.updatePosition({ x: playOptions.x, y: playOptions.y }, true);
                    } emitter.onComplete = () => {
                        emitter.onComplete = () => { };
                        if (isStage) console.log(`[ParticlesController] 🧹 Эффект "${effectName}" завершился.`);
                        this.killParticle(emitter);
                    }; emitter.play();
                } else {
                    emitter = new EmitterClass(parentContainer, finalConfig); if (playOptions.x !== undefined && playOptions.y !== undefined) {
                        emitter.updateOwnerPos(playOptions.x, playOptions.y);
                    } else {
                        emitter.updateOwnerPos(0, 0);
                    }
                    emitter.emit = true;
                }
            } catch (error) {
                console.error(
                    ` [ParticlesController] ❌ КРИТИЧЕСКАЯ ОШИБКА при сборке эффекта "${effectName}":`,
                    error
                );
                return null;
            } const emitterItem = {
                emitter,
                parentContainer,
                followTarget: playOptions.follow,
                name: effectName,
                isStopped: false,
            }; this.activeEmitters.push(emitterItem); if (isStage)
            console.log(
                `[ParticlesController] 🎯 УСПЕХ: Эффект "${effectName}" запущен и добавлен в activeEmitters!`
            ); return emitter;
    } stopParticle(emitter) {
        if (!emitter) return; if (this.options.libType === 'custom') {
            emitter.stop();
            const index = this.activeEmitters.findIndex((item) => item.emitter === emitter);
            if (index !== -1) this.activeEmitters[index].isStopped = true;
        } else {
            emitter.emit = false;
        }
    } killParticle(emitter) {
        const index = this.activeEmitters.findIndex((item) => item.emitter === emitter);
        if (index !== -1) {
            this._destroyEmitterItem(this.activeEmitters[index], index);
        }
    } addToContainerInRunTime(container, effectName) {
        this.view.addToContainerInRunTime(container, effectName);
    } _destroyEmitterItem(item, index) {
        if (typeof item.emitter.destroy === 'function') {
            item.emitter.onComplete = () => { };
            item.emitter.destroy();
        }
        this.activeEmitters.splice(index, 1);
    } stopAll() {
        [...this.activeEmitters].forEach((item, index) => {
            if (this.options.libType === 'custom') item.emitter.stop();
            this._destroyEmitterItem(item, index);
        });
        this.activeEmitters = [];
    }

    destroy() {
        this.stopAll();
        this.emittersMap.clear();
        Ticker.shared.remove(this.update, this);
        this.view.destroy();
    }
}
